export function historyNavigation() {
    window.onpopstate = (event) => {
        console.log(`location: ${document.location}, state: ${JSON.stringify(event.state)}`);
        window.location.reload(true);
    };
}

export function scrollUp(element) {
    const catalog = document.querySelector('.catalog');
    const scrollElement = element || catalog || document.body;

    scrollElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
    });
}
